import { useState, useRef, useEffect } from "react";
import env from "react-dotenv";

const Bwg800 = ({ param }) => {
    console.log(param);
    const [width, setWidth] = useState(0);
    const ref = useRef(null);

    const RenderList = ({ param }) => {
        const item = param.item;
        const index = param.index;
        return (
            <>
                <div key={index} style={{ color: 'white', display: "grid", gridTemplateColumns: "15% 85%", paddingTop: width / 100 + "px" }}>
                    <div className="Center Vertically Horizontally" style={{ fontSize: width / 40 + "px" }}>
                        <div style={{ width: width / 100 + "px", height: width / 100 + "px", backgroundColor: "white", borderRadius: "50%" }}>
                        </div>
                    </div>

                    <div className="Center Vertically">
                        <span className="temponetext" style={{ fontSize: width / 50 + "px" }}>
                            {item['name']}
                        </span>
                    </div>
                </div>
            </>
        )
    }

    useEffect(() => {
        if (ref.current) {
            setWidth(ref.current.offsetWidth);

        }
    }, [width]);
    return (
        <div style={{ width: "100%", backgroundColor: "white", height: "fit-content" }} ref={ref}>
            <div className="Center" style={{ gridTemplateColumns: "34% 66%" }}>
                <div style={{ background: "#183851", height: "fit-content" }}>
                    {
                        // image
                    }
                    <div className="Center Horizontally" style={{}}>
                        <div>
                            <img src={(env.REACT_APP_ENV === "PROD" ? env.REACT_APP_BH_PROD : env.REACT_APP_BH_DEV) + param.userData.candidate.picture} style={{ width: (width * 34 / 100 * 2 / 3) + "px", height: (width * 34 / 100 * 2 / 3) + "px", borderRadius: '50%', border: width / 90 + "px solid white", margin: width / 50 + "px 0" }} alt={param.userData.candidate.picture}/>
                        </div>
                    </div>

                    <div className="Center Horizontally" style={{ color: "white" }}>
                        <div style={{ width: width * 34 / 100 * 2.3 / 3 }}>
                            {
                                // contact
                            }
                            <div>
                                <p className="Temponesubheader" style={{ fontSize: width / 35 + "px" }}>
                                    CONTACT
                                </p>

                                <div style={{ marginTop: -width / 35 + "px", lineHeight: width / 500 }}>
                                    <span className="temponetext" style={{ fontSize: width / 50 + "px", textDecoration:"none" }}>
                                        {param.userData.candidate.phone_number}
                                    </span>
                                    <br />
                                    <span className="temponetext" style={{ fontSize: width / 50 + "px", textDecoration:"none" }}>
                                        {param.userData.candidate.email}
                                    </span>
                                    <br />
                                    <span className="temponetext" style={{ fontSize: width / 50 + "px" }}>
                                        {param.userData.candidate.address}
                                    </span>
                                    {param.userData.candidate.address_cont &&
                                        <span className="temponetext" style={{ fontSize: width / 50 + "px" }}>
                                            &nbsp;{param.userData.candidate.address_cont}
                                        </span>
                                    }
                                    <br />
                                    <span className="temponetext" style={{ fontSize: width / 50 + "px" }}>
                                        &nbsp;{param.userData.candidate.website}
                                    </span>
                                </div>

                            </div>


                            {
                                // education
                            }

                            <div>
                                <p className="Temponesubheader" style={{ fontSize: width / 35 + "px" }}>
                                    EDUCATION
                                </p>
                                <div style={{ marginTop: -width / 35 + "px", lineHeight: width / 500 }}>
                                    {
                                        param.userData.education.map((item, index) =>
                                            <div key={index}>
                                                <span className="temponetext" style={{ fontSize: width / 50 + "px", fontWeight: '600' }}>
                                                    {item['start_date'].substring(0, 4)} - {item['graduation_date'].substring(0, 4)}
                                                </span> <br />

                                                <span className="temponetext" style={{ fontSize: width / 50 + "px" }}>
                                                    {item['school_name']}
                                                </span> <br />
                                                <span className="temponetext" style={{ fontSize: width / 50 + "px" }}>
                                                    {item['degree_name']}
                                                </span> <br />
                                                <span className="temponetext" style={{ fontSize: width / 50 + "px" }}>
                                                    {item['grading']}
                                                </span> <br />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>



                            {
                                // skills
                            }

                            <div>
                                <p className="Temponesubheader" style={{ fontSize: width / 35 + "px" }}>
                                    SKILLS
                                </p>
                                <div style={{ marginTop: -width / 35 + "px", lineHeight: width / 500, display: "grid"}}>


                                    {
                                        param.userData.skills.map((item, index) =>
                                            <RenderList param={{ 'item': item, 'index': index }} key={index}/>
                                        )
                                    }

                                </div>
                            </div>


                            {
                                // languages
                            }

                            <div>
                                <p className="Temponesubheader" style={{ fontSize: width / 35 + "px" }}>
                                    Languages
                                </p>
                                <div style={{ marginTop: -width / 35 + "px", lineHeight: width / 500 }}>


                                    {
                                        param.userData.languages.map((item, index) =>
                                            <RenderList param={{ 'item': item, 'index': index }} key={index}/>
                                        )
                                    }

                                </div>
                            </div>


                        </div>

                    </div>

                
                
                <br/><br/>
                </div>



                <div style={{ padding: width / 90, paddingRight: width / 20, background:"white", height:"fit-content" }}>
                    <div>
                        {
                            // name
                        }
                        <div className="Center Vertically Horizontally" style={{ minHeight: width * 0.275 + "px" }}>
                            <p>
                                <span id="firstName" style={{ fontSize: width / 25 + "px", fontWeight: "900", color: "rgb(70, 70, 70)", textTransform: "uppercase" }}>
                                    {param.userData.candidate.first_name}
                                </span> &nbsp;
                                <span id="lastName" style={{ fontSize: width / 25 + "px", fontWeight: "100", color: "rgb(20, 20, 20)", textTransform: "uppercase" }}>
                                    {param.userData.candidate.last_name}
                                </span>
                                <br />
                                <span id="jobTitle" style={{ fontSize: width / 35 + "px", fontWeight: "100", color: "rgb(20, 20, 20)", textTransform: "uppercase", borderBottom: width / 300 + "px solid #183851", paddingBottom: width / 100 + "px" }}>
                                    {
                                        param.userData.candidate.job_role.substring(0, param.userData.candidate.job_role.length / 4)
                                    }
                                </span>
                                <span style={{ fontSize: width / 35 + "px", fontWeight: "100", color: "rgb(20, 20, 20)", textTransform: "uppercase" }}>
                                    {
                                        param.userData.candidate.job_role.substring(param.userData.candidate.job_role.length / 4, param.userData.candidate.job_role.length)
                                    }
                                </span>
                            </p>
                        </div>

                        {
                            // profile
                        }
                        <div style={{ lineHeight: width / 1200 + "" }}>

                            <p className="Temponesubheader" style={{ fontSize: width / 35 + "px", color: "#183851", borderBottom: "2px solid #183851", paddingBottom: width / 100 + "px" }}>
                                PROFILE
                            </p>
                            <span style={{ fontSize: width / 75 + "px", lineHeight: width / 500 }}>
                                {param.userData.candidate.summary}
                            </span>


                        </div>

                        {
                            // WOrk experience
                        }
                        <div >

                            <p className="Temponesubheader" style={{ fontSize: width / 35 + "px", color: "#183851", borderBottom: "2px solid #183851", paddingBottom: width / 100 + "px" }}>
                                WORK EXPERIENCE
                            </p>
                            <div style={{ marginTop: -width / 100 + "px", display:'grid', gap : width/50+"px" }}>
                                {
                                    param.userData.work_exps.map((item, index) =>

                                        <div style={{ color: "#183851", lineHeight: width / 400 + "" }} key={index}>

                                            <div>

                                                <div style={{display:"grid", gridTemplateColumns :"10% 90%", justifyContent:"space-around"}} className="Vertically">

                                                    <div className="Center Horizontally Vertically">

                                                    <div style={{ width: width / 100 + "px", height: width / 100 + "px", backgroundColor: "#183851", borderRadius: "50%" }} >

                                                    </div>
                                                    </div>
                                                    <div className="Center" style={{ marginBottom: width / 200, fontWeight: "700", gridTemplateColumns: "50% 50%" }}>
                                                        <div>


                                                            <span style={{ fontSize: width / 40 + "px", display: "flex" }}>
                                                                {item['company']}
                                                            </span>
                                                        </div>

                                                        <div>
                                                            <span style={{ float: "right", fontSize: width / 60 + "px", display: "flex" }}>
                                                                {item['date_start'].substring(0, 4)} - {item['is_current'] ? "PRESENT" : item['date_end'].substring(0, 4)}
                                                            </span>
                                                        </div>
                                                    </div>

                                                </div>


                                                <div style={{ marginBottom: width / 200, paddingLeft:"10%" }}>
                                                    <span style={{ fontSize: width / 50 + "px", display: "flex" }}>
                                                        {item['title']}
                                                    </span>
                                                </div>

                                                <div style={{paddingLeft:"10%"}}>
                                                    <div>
                                                        {item.keyRes.map((itemInner, indexInner) =>
                                                            <div style={{ display: "grid", gridTemplateColumns: "10% 90%" }}>
                                                                <div>

                                                                </div>

                                                                <div>

                                                                    <li style={{ color: "#183851", fontSize: width / 55 + "px" }} key={indexInner} >
                                                                        {itemInner}
                                                                    </li>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    )
                                }
                            </div>


                        </div>

                        {
                            // References
                        }

                        <div style={{}}>

                            <p className="Temponesubheader" style={{ fontSize: width / 35 + "px", color: "#183851", borderBottom: "2px solid #183851", paddingBottom: width / 100 + "px" }}>
                                REFERENCES
                            </p>
                            <div style={{ display: "grid", gridTemplateColumns: " 50% 50%", justifyContent: "space-around" }}>
                                {param.userData.refs.map((item, index) =>
                                    <div className="Center Horizontally" key={index}>

                                        <div style={{ lineHeight: width / 450 + "" }} >
                                            <span style={{ fontSize: width / 50 + "px" }}>
                                                <b>

                                                    {item['full_name']}
                                                </b>
                                            </span> <br />
                                            <span style={{ textTransform: "capitalize", fontSize: width / 50 + "px" }}>
                                                {item['address']}
                                            </span> <br />
                                            <span style={{ fontSize: width / 50 + "px" ,  textDecoration:"none"}}>
                                                {item['phone_number']}
                                            </span> <br />
                                            <span style={{ fontSize: width / 50 + "px", textDecoration:"none" }}>
                                                {item['email']}
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </div>
    )
}

export default Bwg800;